/**
 * shows popup message with provided params
 * @param {String} title for popup
 * @param {String} message - content for message
 * @param {String} buttonText - text on button success
 * @param {Function} buttonHandler - callback for button success click
 */
export function showPopup(title, message, buttonText, buttonHandler) {
    const popupWrapper = document.getElementById('en-popup-wrapper');
    const popupTitle = document.getElementById('en-popup-title');
    const popupMessage = document.getElementById('en-popup-message');
    const button = document.getElementById('en-popup-button-ok');

    if (!popupWrapper || !popupTitle || !popupMessage || !button) return;

    popupWrapper.classList.add('visible');

    popupTitle.innerText = title;
    popupMessage.innerText = message;
    button.innerText = buttonText;

    button.onclick = () => {
        buttonHandler?.();
        popupWrapper.classList.remove('visible');
    };
}

export function hidePopup(popup) {
    if (!(popup instanceof Element)) return;

    const eventName = popup.getAttribute('data-custom-close-event');
    if (eventName) {
        // Use `detail` for passing data with CustomEvent (standard way)
        window.dispatchEvent(new CustomEvent(eventName, { detail: { popup } }));
    }

    popup.classList.remove('visible');
}

export default function initPopups() {
    document.addEventListener('click', (e) => {
        const target = e.target instanceof Element ? e.target : null;
        if (!target) return;

        // cancel if datepicker was clicked
        if (
            target.classList.contains('datepicker-dropdown') ||
            target.closest('.datepicker-dropdown')
        ) {
            return;
        }

        // cancel if context menu was clicked
        if (target.closest('.en-data-context-menu')) {
            return;
        }

        // determine which popup (if any) was clicked
        const clickedPopup =
            (target.classList.contains('en-popup') && !target.classList.contains('en-popup__inner'))
                ? target
                : target.closest('.en-popup');

        const visiblePopups = document.querySelectorAll('.en-popup.visible');

        for (const popup of visiblePopups) {
            // hide on click on backdrop / hide button
            if (
                target.classList.contains('en-popup-backdrop') ||
                target.classList.contains('en-popup-hide')
            ) {
                hidePopup(popup);
                continue;
            }

            // don’t hide if current popup clicked
            if (clickedPopup instanceof Element && clickedPopup === popup) {
                continue;
            }

            hidePopup(popup);
        }
    });
}
